import Vue from 'vue'
import Router from 'vue-router'
// eslint-disable-next-line no-unused-vars
import cookie from '~/utils/cookie'
import ProgressBar from '~/components/progress-bar.vue'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  // 首页
  {
    path: '/',
    redirect: '/index'
  },
  // 登录
  {
    path: '/login',
    component: () => import('../views/login')
  },
  // 功能页
  {
    path: '/index',
    component: () => import('../views/index'),
    meta: {
      authentication: true,
      role: [1, 2]
    },
    children: [
      {
        path: 'users',
        component: () => import('../views/index/users'),
        meta: {
          role: [2],
          activePathName: 'users'
        }
      },
      {
        path: 'comments',
        component: () => import('../views/index/comments'),
        meta: {
          role: [1, 2],
          activePathName: 'comments'
        }
      },
      {
        path: 'admins',
        component: () => import('../views/index/admins'),
        meta: {
          role: [2],
          activePathName: 'admins'
        }
      },
      {
        path: 'journal/:id',
        component: () => import('../views/index/journal-comment'),
        meta: {
          role: [1, 2],
          activePathName: 'comments'
        }
      },
      // 优惠券管理
      {
        path: 'coupons',
        component: () => import('../views/index/coupons'),
        meta: {
          role: [1, 2],
          activePathName: 'coupons'
        }
      },
      // 此优惠券领取的列表
      {
        path: 'coupons/:id',
        component: () => import('../views/index/coupons/detail/coupon-detail.vue'),
        meta: {
          role: [1, 2],
          activePathName: 'coupons'
        }
      },
      // 轮播图管理
      // {
      //   path: 'banners',
      //   component: () => import('../views/index/banners'),
      //   meta: {
      //     role: [1, 2],
      //     activePathName: 'banners'
      //   }
      // },
      // 轮播图管理
      {
        path: 'carousel-manage',
        component: () => import('../views/index/carousel-manage'),
        meta: {
          role: [1, 2],
          activePathName: 'carousel-manage'
        }
      },
      {
        path: 'ranking',
        component: () => import('../views/index/journal-ranking'),
        meta: {
          role: [1, 2],
          activePathName: 'ranking'
        }
      },
      {
        path: 'guide',
        component: () => import('../views/index/content-manage/selection-guide'),
        meta: {
          role: [1, 2],
          activePathName: 'guide'
        }
      },
      {
        path: 'guide-form',
        component: () => import('../views/index/content-manage/selection-guide/guide-form'),
        meta: {
          role: [1, 2],
          activePathName: 'guide'
        }
      },
      {
        path: 'announcement',
        component: () => import('../views/index/content-manage/latest-announcement'),
        meta: {
          role: [1, 2],
          activePathName: 'announcement'
        }
      },
      {
        path: 'announcement-form',
        component: () => import('../views/index/content-manage/latest-announcement/announcement-form'),
        meta: {
          role: [1, 2],
          activePathName: 'announcement'
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('../views/404.vue')
  },
  // 当使用通配符路由时，请确保路由的顺序是正确的，也就是说含有通配符的路由应该放在最后
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  // 如果需要身份验证
  if (to.matched.some(record => record.meta.authentication)) {
    // cookie 中没有token 是： undefined "token" (undefined: 返回一个未定义的对象)
    let token = cookie.get('T_j_cms_token')
    // 必须登录
    if (token) {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (!userInfo) {
        cookie.remove('T_j_cms_token')
        next('/login')
      } else if (to.meta.role.includes(userInfo.userRole)) {
        next()
      } else {
        next('/404')
      }
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js